export default __webpack_public_path__ + "static/media/forest03.c23ac8bd.jpeg";